const baseUrl = process.env.REACT_APP_API_BASE_URL
const ibanUrl = process.env.REACT_APP_IBAN_API_BASE_URL
export {
    ibanUrl,
    baseUrl
}
